<h2 mat-dialog-title>{{ (firstName ? 'welcome.titleWithName' : 'welcome.title') | translate:{name: firstName} }}</h2>

<mat-dialog-content class="welcome-content">
  <p class="intro">
    {{ 'welcome.intro' | translate }}
  </p>

  <div class="topic" *ngFor="let t of topics">
    <mat-icon class="topic-icon">{{ t.icon }}</mat-icon>
    <div>
      <div class="topic-title">{{ t.titleKey | translate }}</div>
      <div class="topic-body">{{ t.bodyKey | translate }}</div>
    </div>
  </div>

  <div class="notice" *ngIf="data.rights && !data.rights.writeEmployees">
    <mat-icon>visibility</mat-icon>
    <span>{{ 'welcome.readOnlyNotice' | translate }}</span>
  </div>

  <p class="footnote">
    {{ 'welcome.footnote' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="openHelp()">{{ 'welcome.readFullGuide' | translate }}</button>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'welcome.gotIt' | translate }}</button>
</mat-dialog-actions>
